import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibMoreHorizIcon } from '@chewy/kib-icons-react'

import RhapSoapHeaderMenu from './RhapSoapHeaderMenu'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'

export const SoapHeaderMenuButton = () => {
  const { t } = useTranslation('Common')
  const buttonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <KibButtonNew
        iconOnly
        aria-label={t('ACTIONS_MENU')}
        emphasis="tertiary"
        icon={<KibMoreHorizIcon />}
        ref={buttonRef}
        theme="utility"
      />
      <RhapSoapHeaderMenu triggerRef={buttonRef} />
    </>
  )
}
